// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"5b642462","58":"3b70dd4f","158":"7e2b4de5","394":"696c397d","453":"8d14d7bf","546":"dcba2fea","615":"c4c42664","733":"27c30b76","911":"54dbafe3"}[chunkId] + ".chunk.js";
};